import React from 'react';
import { useTranslation } from 'react-i18next';
import type { VisibilityReportBrandPresence } from '@brand24-original/llm-types';
import ReportSection from './ReportSection';
import ReportMatrixTable from './ReportMatrixTable';

interface ReportBrandPresenceProps {
  presence: VisibilityReportBrandPresence;
  /** Wspólna dla całego raportu mapa kolorów marek. */
  brandColors: Map<string, string>;
}

/** Gdzie każda marka pojawia się w tematach, o które pytają klienci — ta sama heatmapa co macierz. */
export const ReportBrandPresence: React.FC<ReportBrandPresenceProps> = ({
  presence,
  brandColors,
}) => {
  const { t } = useTranslation();

  // Slajd bez danych w ogóle nie wchodzi do raportu — projekt może nie mieć jeszcze insightów.
  if (presence.topics.length === 0 || presence.rows.length === 0) {
    return null;
  }

  return (
    <ReportSection
      title={t('reportPresenceTitle')}
      titleAccent={t('reportPresenceTitleAccent')}
      subtitle={t('reportPresenceSubtitle')}
    >
      {/* Tematów bywa kilka razy więcej niż modeli, więc tu tabela jedzie w poziomie. */}
      <ReportMatrixTable
        columns={presence.topics}
        rows={presence.rows}
        brandColors={brandColors}
        scrollable
      />
    </ReportSection>
  );
};

export default ReportBrandPresence;
